<template>
  <div class="row mx-0 mb-2 py-1 bg-white shadow">
    <div class="col-3 my-auto cut-text" :title="variable.titel">{{ variable.titel }}</div>
    <div class="col-2 my-auto cut-text" :title="variable.platzhalter">{{ variable.platzhalter }}</div>
    <div class="col-1 my-auto cut-text" :title="variable.herkunft">{{ variable.herkunft }}</div>
    <div class="col-2 my-auto cut-text" :title="variable.feld">{{ variable.feld }}</div>
    <div class="col-1 my-auto">{{ typeConverter }}</div>
    <div class="col-2 my-auto">
      <span v-for="gruppe in gruppen" :key="gruppe" class="badge text-bg-primary me-1 mb-1">{{ gruppe }}</span>
    </div>
    <div class="col-1 my-auto d-flex justify-content-between">
      <span>{{ count }}</span>
      <EditVariableModal :index="variable.id" :buttonType="1" :variable="variable" @delete-variable="deleteVariable" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, computed } from 'vue';
  import { useStore } from 'vuex';
  import { ActionTypes as VariablenActionTypes } from '@/store/modules/Variablen/actions';

  import { Variable } from '@/models/VorlageModels';

  import EditVariableModal from '@/components/Vorlagen/EditVariableModal.vue';
  //#endregion

  const { variable } = defineProps({
    variable: {
      type: Object as PropType<Variable>,
      required: true,
    },
  });

  const store = useStore();

  const typeConverter = computed(() => {
    if (variable.type === 'date' && variable.validationType === 'today') {
      return 'Datum Heute';
    } else if (variable.type === 'date') {
      return 'Datum';
    } else if (variable.type === 'text') {
      if (variable.values.length > 0 && variable.values[0].type === 'select') {
        return 'Auswahl';
      } else if (variable.values.length > 0 && variable.values[0].type === 'summe') {
        return 'Summe';
      } else if (variable.validationType === 'text') {
        return 'Text';
      } else if (variable.validationType === 'float') {
        return 'Zahl';
      } else if (variable.validationType === 'currency') {
        return 'Währung';
      } else if (variable.validationType === 'usersignature') {
        return 'Benutzersignatur';
      } else {
        return 'Unbekannt';
      }
    } else {
      return 'Unbekannt';
    }
  });

  const count = computed(() => {
    let counter = 0;

    let textKey = variable.platzhalter.replace('<<', '&lt;&lt;');
    textKey = textKey.replace('>>', '&gt;&gt;');

    for (const baustein of store.getters.textbausteine) {
      if (baustein.text != undefined && baustein.text?.includes(textKey)) {
        counter++;
      }

      if (baustein.abschnitte && baustein.abschnitte.length > 0) {
        for (const abschnitt of baustein.abschnitte) {
          if (abschnitt.text != undefined && abschnitt.text?.includes(textKey)) {
            counter++;
          }
        }
      }
    }

    return counter;
  });

  const gruppen = computed(() => {
    const uniqueGruppen = new Array<string>();

    const gruppen = variable.gruppe.split(';');

    gruppen.forEach((gruppe) => {
      const trimmedGruppe = gruppe.trim();
      if (trimmedGruppe !== '' && !uniqueGruppen.includes(trimmedGruppe)) {
        uniqueGruppen.push(trimmedGruppe);
      }
    });

    return uniqueGruppen.sort();
  });

  function deleteVariable(id: number) {
    store.dispatch(VariablenActionTypes.DeleteVariable, id);
  }
</script>

<style lang="css" scoped>
  .cut-text {
    overflow: hidden;
    white-space: nowrap; /* Don't forget this one */
    text-overflow: ellipsis;
  }
</style>
